export enum DependenciesFilterOptions {
  All = 'ALL',
  WithAccess = 'WITHACCESS',
  Upstream = 'UPSTREAM',
  Downstream = 'DOWNSTREAM',
  DownstreamBIAssets = 'DOWNSTREAMBIASSETS',
  CriticalAssets = 'CRITICALASSETS',
}

export type DependenciesTableFiltersCountersData = {
  asset: {
    all: string[];
    withAccess: string[];
    upstream: string[];
    downstream: string[];
    downstreamBIAssets: string[];
    criticalAssets: string[];
  };
};

export type DependenciesColumnFiltersCountersData = {
  asset: {
    column: {
      all: string[];
      withAccess: string[];
      upstream: string[];
      downstream: string[];
      downstreamBIAssets: string[];
      criticalAssets: string[];
    };
  };
};

export type DependenciesFiltersCountersData =
  DependenciesTableFiltersCountersData & DependenciesColumnFiltersCountersData;

export type DependenciesFiltersCounters = {
  [DependenciesFilterOptions.All]: number | undefined;
  [DependenciesFilterOptions.WithAccess]: number | undefined;
  [DependenciesFilterOptions.Upstream]: number | undefined;
  [DependenciesFilterOptions.Downstream]: number | undefined;
  [DependenciesFilterOptions.DownstreamBIAssets]: number | undefined;
  [DependenciesFilterOptions.CriticalAssets]: number | undefined;
};
